import {Component} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import {screenSize} from "../../../../shared/core/shared.selectors";

@Component({
  selector: 'app-group-details-screen-shimmer-loader',
  templateUrl: './group-details-screen-shimmer-loader.component.html',
  styleUrls: ['./group-details-screen-shimmer-loader.component.css']
})
export class GroupDetailsScreenShimmerLoaderComponent {
  screenSize = '';
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store,
  ) {
    this.store.select(screenSize).pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.screenSize = data;
      });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
